import { NsCard } from 'components/common/ns-card/NsCard';
import { NsContent } from 'components/common/ns-content/NsContent';

export const energyNeedsSidebarRightTestId = 'energyNeedsSidebarRightTestId';
export const EnergyNeedsSidebarRight = () => {
  return (
    <NsContent data-testid={energyNeedsSidebarRightTestId}>
      <NsCard
        heading="Refer a friend and share up to £100"
        decoration="multiplePeople"
      >
        Recommend a friend to join us, and you both could get an Amazon Gift
        Card worth up to £50 (that&apos;s £100 between you!)
      </NsCard>
      <NsCard heading="Save on Sundays" decoration="savings">
        You can enjoy half-price electricity every Sunday, 11am to 4pm, with
        PeakSave.
      </NsCard>
      <NsCard heading="You’re in control" decoration="rosette-tick-green">
        If we offer a cheaper tariff, you can make the switch any time -{' '}
        <strong>free</strong>.
      </NsCard>
    </NsContent>
  );
};

export default EnergyNeedsSidebarRight;
